import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { getElapsedHours } from '../utilities/DateHelpers';
import { roundToAtMost2Decimals } from '../utilities/NumberHelpers';
import { getTreatAsRemoved } from './TimesheetDetail';

export default class TotalTimeIndicator extends React.Component {
    getHoursWorked() {
        const { timesheet } = this.props;

        let laborHours = 0;
        let equipmentHours = 0;

        timesheet.timesheetDetails
            .filter((td) => !getTreatAsRemoved(td))
            .forEach((td) => {
                const hoursWorked = getElapsedHours(
                    td.adjustedStart ?? td.start,
                    td.adjustedEnd ?? td.end
                );

                if (td.employeeId) {
                    laborHours += hoursWorked;
                } else {
                    equipmentHours += hoursWorked;
                }
            });

        return {
            laborHours: roundToAtMost2Decimals(laborHours),
            equipmentHours: roundToAtMost2Decimals(equipmentHours),
            totalHours: roundToAtMost2Decimals(laborHours + equipmentHours),
        };
    }

    render() {
        const { loading, timesheet } = this.props;

        if (loading || !timesheet) {
            return null;
        }

        const { laborHours, equipmentHours, totalHours } =
            this.getHoursWorked();

        return (
            <div className="grid-col total-time-indicator phase-grid-right-col">
                <Card color="secondary">
                    <CardHeader>Total: {totalHours} hrs</CardHeader>
                    <CardBody>
                        {Boolean(laborHours > 0) && (
                            <div>Labor: {laborHours} hrs</div>
                        )}

                        {Boolean(equipmentHours > 0) && (
                            <div>Equipment: {equipmentHours} hrs</div>
                        )}
                    </CardBody>
                </Card>
            </div>
        );
    }
}
